import React, { MouseEvent, useState } from 'react'
import { InclusionIcon, DiversityIcon, SurveyIcon, PlusIcon, Button } from '@diversioteam/diversio-ds'

import { useCreatePulseSurvey } from 'hooks/pulseSurveys/useCreatePulseSurvey'

import { PulseSurveysProps } from './pulseSurveys.types'
import * as S from './pulseSurveys.styles'

const PUlSE_SURVEYS_MENU_ICON_BASE_PROPS = {
    type: 'line',
    color: 'white',
    width: 16,
    height: 16,
} as const

export const PulseSurveys = ({
    isCollapsed,
    onCollapse,
    onOpenExperienceDialog,
    onOpenPeopleDialog,
}: PulseSurveysProps) => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

    const { mutate } = useCreatePulseSurvey()

    const handleCreateSurvey = () => {
        mutate()

        handleClosePopover()
    }

    const handleOpenPopover = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)

        setIsPopoverOpen(true)
    }

    const handleClosePopover = () => {
        setAnchorEl(null)

        setIsPopoverOpen(false)

        onCollapse()
    }

    const handleOpenExperienceDialog = () => {
        onOpenExperienceDialog()

        handleClosePopover()
    }

    const handleOpenPeopleDialog = () => {
        onOpenPeopleDialog()

        handleClosePopover()
    }

    return (
        <S.PulseSurveysWrapper>
            {isCollapsed ? (
                <Button iconOnly onClick={handleOpenPopover}>
                    <PlusIcon type="line" />
                </Button>
            ) : (
                <Button onClick={handleOpenPopover} leftIcon={<PlusIcon type="line" />} fullWidth>
                    New survey
                </Button>
            )}

            <S.Popover
                open={isPopoverOpen}
                anchorEl={anchorEl}
                onClose={handleClosePopover}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <S.PulseSurveys>
                    <S.PulseSurveysTitle>Select survey type</S.PulseSurveysTitle>

                    <S.PulseSurveysList>
                        <S.PulseSurveysListItem role="button" onClick={handleOpenExperienceDialog}>
                            <S.PulseSurveysListItemHeader>
                                <InclusionIcon {...PUlSE_SURVEYS_MENU_ICON_BASE_PROPS} /> Experience
                            </S.PulseSurveysListItemHeader>

                            <S.PulseSurveysListItemDescription>
                                Learn how your people feel. Requires CSM support.
                            </S.PulseSurveysListItemDescription>
                        </S.PulseSurveysListItem>

                        <S.PulseSurveysListItem role="button" onClick={handleOpenPeopleDialog}>
                            <S.PulseSurveysListItemHeader>
                                <DiversityIcon {...PUlSE_SURVEYS_MENU_ICON_BASE_PROPS} /> People
                            </S.PulseSurveysListItemHeader>

                            <S.PulseSurveysListItemDescription>
                                Learn who your people are. Requires CSM support.
                            </S.PulseSurveysListItemDescription>
                        </S.PulseSurveysListItem>

                        <S.PulseSurveysListItem onClick={handleCreateSurvey}>
                            <S.PulseSurveysListItemHeader>
                                <SurveyIcon {...PUlSE_SURVEYS_MENU_ICON_BASE_PROPS} /> Pulse
                            </S.PulseSurveysListItemHeader>

                            <S.PulseSurveysListItemDescription>
                                Check-in on your team.
                            </S.PulseSurveysListItemDescription>
                        </S.PulseSurveysListItem>
                    </S.PulseSurveysList>
                </S.PulseSurveys>
            </S.Popover>
        </S.PulseSurveysWrapper>
    )
}
